import React from "react";
import "./Blogs.css";
import Blog1Image from "../assests/images/blogs/blog1image.png";
import Blog2Image from "../assests/images/blogs/blog2image.png";
import Blog3Image from "../assests/images/blogs/blog3image.png";
import Blog4Image from "../assests/images/blogs/blog4image.png";
import Blog5Image from "../assests/images/blogs/blog5image.png";
import Blog6Image from "../assests/images/blogs/blog6image.png";
import Blog7Image from "../assests/images/blogs/blog7image.png";
import Blog8Image from "../assests/images/blogs/blog8image.png";
import Blog9Image from "../assests/images/blogs/blog9image.png";
import Blog10Image from "../assests/images/blogs/blog10image.png";
import Blog11Image from "../assests/images/blogs/blog11image.png";
import Blog12Image from "../assests/images/blogs/blog12image.png";
import Blog13Image from "../assests/images/blogs/blog13image.png";
import Blog14Image from "../assests/images/blogs/blog14image.png";
import Blog15Image from "../assests/images/blogs/blog15image.png";
import Blog16Image from "../assests/images/blogs/blog16image.png";
import Blog17Image from "../assests/images/blogs/blog17image.png";
import Blog18Image from "../assests/images/blogs/blog18image.png";
import Blog19Image from "../assests/images/blogs/blog19image.png";
import Blog20Image from "../assests/images/blogs/blog20image.png";

import { redirect } from "react-router-dom";

const Blogs = () => {
  const blogPosts = [
    {
      id: 1,
      image: Blog1Image,
      title: "Voice Search Is Booming: Is Your Website Speaking the Right Language?",
      date: "July 26, 2025",
      readTime: "10 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/voice-search-booming-your-website-speaking-right-language-lqf4c/?trackingId=d7Xi9fcEQ1SaTMGzqRqivQ%3D%3D"
    },
    {
      id: 2,
      image: Blog2Image,
      title: "Why 2D Animation Is the New Storytelling Gold for Brands in 2025",
      date: "July 25, 2025",
      readTime: "15 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/why-2d-animation-new-storytelling-gold-brands-2025-zcfcc/?trackingId=02QdEziGRxKuHMTa4OoE8A%3D%3D"
    },
    {
      id: 3,
      image: Blog3Image,
      title: "What Happens When Animation Meets Policy",
      date: "July 24, 2025",
      readTime: "10 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/what-happens-when-animation-meets-policy-anushthan-idea-labs-njnac/?trackingId=nVf73u%2F8RiykbhdNglSEUA%3D%3D"
    },
    {
      id: 4,
      image: Blog4Image,
      title: "No Office? No Problem. We Build Campaigns in the Cloud.",
      date: "July 23, 2025",
      readTime: "7 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/office-problem-we-build-campaigns-cloud-anushthan-idea-labs-vzboc/?trackingId=u941GEMFTySYvKySVO3nvw%3D%3D"
    },
    {
      id: 5,
      image: Blog5Image,
      title: "What “Hyperlocal” Really Means in Political Content",
      date: "July 22, 2025",
      readTime: "7 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/what-hyperlocal-really-means-political-content-anushthan-idea-labs-dsaae/?trackingId=uWUsYGzOSCa7J3ZkZV9HgQ%3D%3D"
    },
    {
      id: 6,
      image: Blog6Image,
      title: "What a Government Campaign Can Learn from a Netflix Trailer",
      date: "July 21, 2025",
      readTime: "8 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/what-government-campaign-can-learn-from-netflix-trailer-zzrrc/?trackingId=wMWVoRfbSgaHgZDWhLFlrg%3D%3D"
    },
    {
      id: 7,
      image: Blog7Image,
      title: "The Smartest Politicians Don’t Just Speak. They Listen at Scale.",
      date: "July 19, 2025",
      readTime: "5 min read",
      redirectUrl: "https://www.linkedin.com/pulse/smartest-politicians-dont-just-speak-listen-scale-zquxc/?trackingId=RUWIFhiNTVO0i2CFoejaTg%3D%3D"
    },
    {
      id: 8,
      image: Blog8Image,
      title: "Your Brand’s First Employee Might Be a Virtual One",
      date: "July 18, 2025",
      readTime: "10 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/your-brands-first-employee-might-virtual-one-anushthan-idea-labs-eu32c/?trackingId=b%2BxFPCrESzCXKckRoZBcVg%3D%3D"
    },
    {
      id: 9,
      image: Blog9Image,
      title: "Why Every Founder Needs a Press Kit in 2025",
      date: "July 17, 2025",
      readTime: "9 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/why-every-founder-needs-press-kit-2025-anushthan-idea-labs-utuwc/?trackingId=FQbckLcCQYSX96sTZtTS8Q%3D%3D"
    },
    {
      id: 10,
      image: Blog10Image,
      title: "Newsletters Aren’t Dead. They’re Just Misunderstood.",
      date: "July 17, 2025",
      readTime: "6 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/newsletters-arent-dead-theyre-just-misunderstood-gsrze/?trackingId=3XECkv38RzyL8GpJaCkEkg%3D%3D"
    },
    {
      id: 11,
      image: Blog11Image,
      title: "The Rise of “Silent Design”: Why Your UI Should Speak Without Words",
      date: "July 16, 2025",
      readTime: "8 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/rise-silent-design-why-your-ui-should-speak-without-kapnc/?trackingId=RzI4H5P%2FTNq9GLJsdUS8lg%3D%3D"
    },
    {
      id: 12,
      image: Blog12Image,
      title: "Our Real Superpower? Creative Engineering.",
      date: "July 16, 2025",
      readTime: "10 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/our-real-superpower-creative-engineering-anushthan-idea-labs-rqlsc/?trackingId=rtRyt9RTSvCdGfX%2BcZDEhw%3D%3D"
    },
    {
      id: 13,
      image: Blog13Image,
      title: "Brand Mascots Are Back. And They’re Smarter.",
      date: "July 15, 2025",
      readTime: "8 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/brand-mascots-back-theyre-smarter-anushthan-idea-labs-xvxdc/?trackingId=f8aalSjZSmaucwR4UdT7ug%3D%3D"
    },
    {
      id: 14,
      image: Blog14Image,
      title: "How We Use Automation to Run Political War Rooms",
      date: "July 14, 2025",
      readTime: "10 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/how-we-use-automation-run-political-war-rooms-anushthan-idea-labs-cyzwc/?trackingId=97ljQnQrTvKB4PTEL2Kt0Q%3D%3D"
    },
    {
      id: 15,
      image: Blog15Image,
      title: "The Rise of B2B Creators—and Why We’re Training Them",
      date: "July 12, 2025",
      readTime: "10 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/rise-b2b-creatorsand-why-were-training-them-anushthan-idea-labs-scn3c/?trackingId=sCB%2BTsyjRLG2SYdeC0CqKQ%3D%3D"
    },
    {
      id: 16,
      image: Blog16Image,
      title: "The Design Trend We’re Betting On? Brutal Simplicity",
      date: "July 12, 2025",
      readTime: "10 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/design-trend-were-betting-brutal-simplicity-anushthan-idea-labs-eoi0c/?trackingId=JKRx%2FQz8SleI712GAa3wmQ%3D%3D"
    },
    {
      id: 17,
      image: Blog17Image,
      title: "Is Your Brand Ready for Spatial Internet?",
      date: "July 11, 2025",
      readTime: "12 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/your-brand-ready-spatial-internet-anushthan-idea-labs-g2y4c/?trackingId=nxI4aMSFTGGVBQzV8f7Xsw%3D%3D"
    },
    {
      id: 18,
      image: Blog18Image,
      title: "The Case for Branding Bureaucrats",
      date: "July 11, 2025",
      readTime: "5 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/case-branding-bureaucrats-anushthan-idea-labs-wdpsc/?trackingId=mG7dJjjdTZyo%2BKiAgUk40w%3D%3D"
    },
    {
      id: 19,
      image: Blog19Image,
      title: "Why Your Brand Needs a Chief Automation Officer (Even if It’s Us)",
      date: "July 10, 2025",
      readTime: "9 mins read",
      redirectUrl: "https://www.linkedin.com/pulse/why-your-brand-needs-chief-automation-officer-even-mrbic/?trackingId=%2FSdEgC7eQLSd%2B1%2B%2BoYAdnw%3D%3D"
    },
    {
      id: 20,
      image: Blog20Image,
      title: "When Political Consulting Meets Meme Strategy",
      date: "July 10, 2025",
      readTime: "10 min read",
      redirectUrl: "https://www.linkedin.com/pulse/when-political-consulting-meets-meme-strategy-anushthan-idea-labs-4nahc/?trackingId=si1rpxDoRdKs%2FEhD2GE1aQ%3D%3D"
    },
  ];

  const latestNews = [
    // {
    //   id: 1,
    //   image: News1Image,
    //   title: "Global leaders unite to address climate crisis at COP26",
    //   description:
    //     "Amid escalating tensions & humanitarian crises in various conflict hotspots around the world leaders have convened to address the",
    //   category: "World News",
    //   date: "April 24, 2025",
    // },
    // {
    //   id: 2,
    //   image: News2Image,
    //   title: "Cybersecurity experts warn of increased threats",
    //   description:
    //     "This warning serves as a stark reminder at the critical imperative to bolster cybersecurity frameworks and stay vigilant against",
    //   category: "World News",
    //   date: "April 24, 2025",
    // },
    // {
    //   id: 3,
    //   image: News1Image,
    //   title: "Athlete achieves historic win at world championships",
    //   description:
    //     "This landmark achievement not only signifies Warren's exceptional prowess and dedication but also stands as a testament to the",
    //   category: "World News",
    //   date: "April 24, 2025",
    // },
    // {
    //   id: 4,
    //   image: News2Image,
    //   title:
    //     "Chemical currents breaking news in chemistry and materials science",
    //   description:
    //     "From unveiling novel compounds and catalysts to pioneering advances in nanotechnology and",
    //   category: "World News",
    //   date: "April 24, 2025",
    // },
  ];

  // Sample data for Trending News
  const trendingNews = [
    // {
    //   id: 1,
    //   title: "Tech giants unveil plans for next generation AI assistants",
    //   date: "April 24, 2025",
    // },
    // {
    //   id: 2,
    //   title: "Government faces backlash over proposed tax reform legislation",
    //   date: "April 24, 2025",
    // },
    // {
    //   id: 3,
    //   title:
    //     "Community health initiative launches campaign to combat childhood",
    //   date: "April 24, 2025",
    // },
    // {
    //   id: 4,
    //   title: "Candidates gear up for highly contested race",
    //   date: "April 24, 2025",
    // },
    // {
    //   id: 5,
    //   title: "Entertainment industry mourns loss of iconic actor",
    //   date: "April 24, 2025",
    // },
  ];

  return (
    <>
      <div className="container mt-150">
        {/* <h1 className="blogs-section-title text-center">Popular Blogs</h1> */}

        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 justify-content-center">
          {blogPosts.map((post) => (
            <div key={post.id} className="col d-flex">
              <div className="blog-card bg-base w-100">
                <img
                  src={post.image}
                  className="blog-card-image"
                  alt={`Blog Post: ${post.title}`}
                />
                <div className="blog-card-body">
                  <h5 className="blog-card-title text-black">{post.title}</h5>
                  <div className="blog-meta">
                    <span>{post.date}</span>
                    <span>{post.readTime}</span>
                  </div>
                  <a href={post.redirectUrl} target="_blank" rel="noreferrer" className="read-more-link">
                    Read more
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Blogs;
